const treeItemPredicate = (filterState) => (treeState) => {
    const isIllegal = filterState.illegal && (
            treeState._contains_illegal ||
            treeState._is_illegal
        );
    const isWarning = filterState.warning && (
            treeState._contains_warning ||
            treeState._is_warning
        );
    const isOk = filterState.ok &&
        (
            treeState._contains_ok ||
            treeState._is_ok
        );
    return isIllegal || isWarning || isOk;
};

export default treeItemPredicate;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/validationtree/treeItemPredicate.js